import React from 'react';
import { Tooltip } from '@mui/material';

/** Tooltip styled like the sidebar's menus; only shown when `show` is set. */
export const SideTip: React.FC<{
  title: string;
  show?: boolean;
  placement?: 'right' | 'top';
  children: React.ReactElement;
}> = ({ title, show = true, placement = 'right', children }) => (
  <Tooltip
    title={show ? title : ''}
    placement={placement}
    disableInteractive
    classes={{ tooltip: 'ens-tip' }}
  >
    {children}
  </Tooltip>
);
